var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.35a.65.65 0 0 1 .65.65v8.43l8.89-8.89a.65.65 0 1 1 .92.92l-8.89 8.89H17a.65.65 0 1 1 0 1.3H7a.65.65 0 0 1-.65-.65V7A.65.65 0 0 1 7 6.35Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDYuMzVDNy4zNTg5OSA2LjM1IDcuNjUgNi42NDEwMiA3LjY1IDdMNy42NSAxNS40MzA4TDE2LjU0MDQgNi41NDAzOEMxNi43OTQyIDYuMjg2NTQgMTcuMjA1OCA2LjI4NjU0IDE3LjQ1OTYgNi41NDAzOEMxNy43MTM1IDYuNzk0MjIgMTcuNzEzNSA3LjIwNTc4IDE3LjQ1OTYgNy40NTk2Mkw4LjU2OTI0IDE2LjM1TDE3IDE2LjM1QzE3LjM1OSAxNi4zNSAxNy42NSAxNi42NDEgMTcuNjUgMTdDMTcuNjUgMTcuMzU5IDE3LjM1OSAxNy42NSAxNyAxNy42NUw3IDE3LjY1QzYuNjQxMDIgMTcuNjUgNi4zNSAxNy4zNTkgNi4zNSAxN0w2LjM1IDdDNi4zNSA2LjY0MTAyIDYuNjQxMDIgNi4zNSA3IDYuMzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";